import { i18n } from "@lingui/core";
import React from 'react';
import { Link } from 'gatsby';
import { useLingui } from '@lingui/react';
import './nav-links.scss'; // DATA

var HEADER_LINK_LIST = [{
  name:
  /*i18n*/
  i18n._("video"),
  slug: 'videos'
}, {
  name:
  /*i18n*/
  i18n._("about"),
  slug: 'about'
}, {
  name:
  /*i18n*/
  i18n._("contact"),
  slug: 'contact'
}];
var SIDE_DRAWER_LINK_LIST = [{
  name:
  /*i18n*/
  i18n._("video"),
  slug: 'videos'
}, {
  name:
  /*i18n*/
  i18n._("about"),
  slug: 'about'
}, {
  name:
  /*i18n*/
  i18n._("contact"),
  slug: 'contact'
}];

var NavLinks = function NavLinks(_ref) {
  var place = _ref.place;

  var _useLingui = useLingui(),
      i18n = _useLingui.i18n;

  var locale = i18n.locale;
  var navLinksJSX;

  switch (place) {
    case 'header':
      navLinksJSX = HEADER_LINK_LIST.map(function (_ref2) {
        var name = _ref2.name,
            slug = _ref2.slug;
        return /*#__PURE__*/React.createElement("li", {
          key: slug
        }, /*#__PURE__*/React.createElement(Link, {
          to: "/" + locale + "/" + slug
        }, i18n._(name)));
      });
      break;

    case 'side-drawer':
      navLinksJSX = SIDE_DRAWER_LINK_LIST.map(function (_ref3) {
        var name = _ref3.name,
            slug = _ref3.slug;
        return /*#__PURE__*/React.createElement("li", {
          key: slug
        }, /*#__PURE__*/React.createElement(Link, {
          to: "/" + locale + "/" + slug
        }, i18n._(name)));
      });
      break;

    default:
      navLinksJSX = null;
      break;
  }

  return /*#__PURE__*/React.createElement("ul", {
    className: "nav-links nav-links--" + place
  }, navLinksJSX);
};

export default NavLinks;